import { useState } from "react";
import { Smartphone, Rocket } from "lucide-react";
import AdminBranding from "@/pages/admin/AdminBranding";
import AdminLanding from "@/pages/admin/AdminLanding";

const GUIAS = [
  { id: "app", label: "Aplicativo", icon: Smartphone },
  { id: "landing", label: "Landing Page", icon: Rocket },
];

export default function AdminIdentity() {
  const [g, setG] = useState("app");
  return (
    <div className="space-y-5" data-testid="admin-identity">
      <div className="flex gap-2" data-testid="identity-guias">
        {GUIAS.map((x) => (
          <button key={x.id} data-testid={`identity-guia-${x.id}`} onClick={() => setG(x.id)}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold border transition-all ${g === x.id ? "bg-accent/15 text-accent border-accent/40" : "bg-card text-muted-foreground border-white/10 hover:text-foreground hover:border-white/20"}`}>
            <x.icon className="h-4 w-4" />{x.label}
          </button>
        ))}
      </div>
      {g === "app" && <AdminBranding />}
      {g === "landing" && <AdminLanding />}
    </div>
  );
}
